import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { TrendingUp, FileText, Users, Euro } from 'lucide-react';

const Statistiken = () => {
  const monthlyData = [
    { monat: 'Jan', gutachten: 12, umsatz: 18900 },
    { monat: 'Feb', gutachten: 15, umsatz: 23600 },
    { monat: 'Mär', gutachten: 11, umsatz: 17300 },
    { monat: 'Apr', gutachten: 14, umsatz: 22100 },
    { monat: 'Mai', gutachten: 16, umsatz: 25200 },
    { monat: 'Jun', gutachten: 13, umsatz: 20500 },
  ];

  const maxGutachten = Math.max(...monthlyData.map(m => m.gutachten));

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Statistiken</h1>
          <p className="text-gray-500 mt-1">Analysieren Sie Ihre Geschäftsdaten</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <Card className="border-0 shadow-lg bg-gradient-to-br from-blue-50 to-blue-100">
            <CardContent className="p-6">
              <div className="flex items-center justify-between mb-2">
                <FileText className="w-8 h-8 text-blue-600" />
                <TrendingUp className="w-5 h-5 text-green-600" />
              </div>
              <p className="text-sm text-blue-600 font-medium">Gutachten Gesamt</p>
              <p className="text-3xl font-bold text-blue-900 mt-1">156</p>
              <p className="text-xs text-blue-600 mt-1">+12% vs. letzter Monat</p>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg bg-gradient-to-br from-purple-50 to-purple-100">
            <CardContent className="p-6">
              <div className="flex items-center justify-between mb-2">
                <Users className="w-8 h-8 text-purple-600" />
                <TrendingUp className="w-5 h-5 text-green-600" />
              </div>
              <p className="text-sm text-purple-600 font-medium">Kunden Gesamt</p>
              <p className="text-3xl font-bold text-purple-900 mt-1">89</p>
              <p className="text-xs text-purple-600 mt-1">12 neue diesen Monat</p>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg bg-gradient-to-br from-green-50 to-green-100">
            <CardContent className="p-6">
              <div className="flex items-center justify-between mb-2">
                <Euro className="w-8 h-8 text-green-600" />
                <TrendingUp className="w-5 h-5 text-green-600" />
              </div>
              <p className="text-sm text-green-600 font-medium">Umsatz Gesamt</p>
              <p className="text-3xl font-bold text-green-900 mt-1">245k €</p>
              <p className="text-xs text-green-600 mt-1">Ø 1.575 € pro Gutachten</p>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg bg-gradient-to-br from-orange-50 to-orange-100">
            <CardContent className="p-6">
              <div className="flex items-center justify-between mb-2">
                <span className="text-3xl">📅</span>
                <TrendingUp className="w-5 h-5 text-green-600" />
              </div>
              <p className="text-sm text-orange-600 font-medium">Dieser Monat</p>
              <p className="text-3xl font-bold text-orange-900 mt-1">18</p>
              <p className="text-xs text-orange-600 mt-1">28.350 € Umsatz</p>
            </CardContent>
          </Card>
        </div>

        {/* Chart */}
        <Card className="border-0 shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <span className="text-2xl">📊</span>
              <span>Gutachten pro Monat (2024)</span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {monthlyData.map((data) => (
                <div key={data.monat} className="flex items-center">
                  <div className="w-12 text-sm font-semibold text-gray-600">{data.monat}</div>
                  <div className="flex-1 mx-4">
                    <div className="h-10 bg-gray-100 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-end pr-3 transition-all"
                        style={{ width: `${(data.gutachten / maxGutachten) * 100}%` }}
                      >
                        <span className="text-white text-sm font-bold">{data.gutachten}</span>
                      </div>
                    </div>
                  </div>
                  <div className="w-24 text-sm text-gray-600 text-right font-semibold">
                    {(data.umsatz / 1000).toFixed(1)}k €
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Statistiken;